module.exports = __webpack_public_path__ + "img/s.935874b7.png";